import { AppConstants } from "../../../Appconstants";

export const getPopoverColumns = (documentType: string) => {
    switch (documentType) {
        case AppConstants.DOCUMENT_TYPE.PURCHASE_ORDER:
        return [
          { title: 'Supplier Name', dataIndex: 'supplierName' },
          { title: 'PO Number', dataIndex: 'documentNumber' },
          { title: 'PO Date', dataIndex: 'documentDate' },
          { title: 'Delivery Date', dataIndex: 'deliveryDate' },
          { title: 'Purchase Request Number', dataIndex: 'indent_number' },
          { title: 'Purchase Request Date', dataIndex: 'indent_date' },
          { title: 'Total Count of Items', dataIndex: 'items' },
          { title: 'Store', dataIndex: 'store' },
          { title: 'Payment Term', dataIndex: 'paymentTerm' },
          { title: 'Total Before Tax', dataIndex: 'totalBeforeTax' },
          { title: 'Total Tax', dataIndex: 'totalTax' },
          { title: 'Total After Tax', dataIndex: 'totalAfterTax' },
          { title: 'Additional Charges', dataIndex: 'additionalCharges' },
          { title: 'Grand Total', dataIndex: 'grandTotal' },
          { title: 'Advance Payment', dataIndex: 'advancePayment' },
          { title: 'Last Modified Date', dataIndex: 'updatedAt' },
          { title: 'CGST', dataIndex: 'cgst' },
          { title: 'SGST', dataIndex: 'sgst' },
          { title: 'IGST', dataIndex: 'igst' },
          { title: 'Supplier Billing Address', dataIndex: 'supplierBillingAddress' },
          { title: 'Supplier Billing Address GSTIN', dataIndex: 'supplierGSTNumber' },
          { title: 'Supplier Billing Address City', dataIndex: 'supplierBillingAddressCity' }, // parse supplierBillingAddress
          { title: 'Customer Billing Address State', dataIndex: 'buyerBillingAddressState' },  // parse buyerBillingAddress
          { title: 'Supplier Billing Address Country', dataIndex: 'supplierBillingAddressCountry' },
          { title: 'Supplier Billing Address PIN', dataIndex: 'supplierBillingAddressPIN' },
          { title: 'Supplier Email', dataIndex: 'supplierEmail' },
          { title: 'Supplier Contact Number', dataIndex: 'supplierContactNo' },
          { title: 'POC Name', dataIndex: 'POCName' },
          { title: 'POC Number', dataIndex: 'POCNumber' },
        ];
  
    case AppConstants.DOCUMENT_TYPE.GOODS_RECEIVED_NOTE:
        return [
          { title: 'Supplier Name', dataIndex: 'supplierName' },
          { title: 'GRN Number', dataIndex: 'grn_number' },
          { title: 'GRN Date', dataIndex: 'grn_Date' },
          { title: 'PO Number', dataIndex: 'documentNumber' },
          { title: 'PO Date', dataIndex: 'documentDate' },
          { title: 'Supplier Invoice Number', dataIndex: 'supplier_invoice_number' },
          { title: 'Supplier Invoice Date', dataIndex: 'supplier_invoice_date' },
          { title: 'Challan Number', dataIndex: 'challan_number' },
          { title: 'Challan Date', dataIndex: 'challan_date' },
          { title: 'Transporter Name', dataIndex: 'transporterName' },
          { title: 'Transporter GSTIN', dataIndex: 'transporterGSTIN' },
          { title: 'Vehicle Number', dataIndex: 'VehicleNumber' },
          { title: 'Supplier Billing Address', dataIndex: 'supplierBillingAddress' },
          { title: 'Supplier Billing Address GSTIN', dataIndex: 'supplierGSTNumber' },
          { title: 'Supplier Billing Address City', dataIndex: 'supplierBillingAddressCity' },
          { title: 'Customer Billing Address State', dataIndex: 'buyerBillingAddressState' },
          { title: 'Supplier Billing Address Country', dataIndex: 'supplierBillingAddressCountry' },
          { title: 'Supplier Billing Address PIN', dataIndex: 'supplierBillingAddressPIN' },
          { title: 'Supplier Email', dataIndex: 'supplierEmail' },
          { title: 'Supplier Contact Number', dataIndex: 'supplierContactNo' },
          { title: 'GRN Created By', dataIndex: 'createdBy' },
        ];
  
    case AppConstants.DOCUMENT_TYPE.QUALITY_REPORT:
        return [
          { title: 'Supplier Name', dataIndex: 'supplierName' },
          { title: 'Supplier GSTIN', dataIndex: 'supplierGSTNumber' },
          { title: 'Quality Report Number', dataIndex: 'qualityReportNumber' },
          { title: 'Quality Report Date', dataIndex: 'qualityReportDate' },
          { title: 'GRN Number', dataIndex: 'grn_number' },
          { title: 'GRN Date', dataIndex: 'grn_Date' },
          { title: 'PO Number', dataIndex: 'documentNumber' },
          { title: 'PO Date', dataIndex: 'documentDate' },
          { title: 'Total Tested Item Count', dataIndex: 'items' }, // Use items.length
          { title: 'Created By', dataIndex: 'createdBy' },
        ];
  
      default:
        return [];
    }
  };
  